import { RootState } from 'state/global-state';

export const selectSelectedOrder = ({ order }: RootState) => order.selectedOrder.order;
